module.exports = __webpack_public_path__ + "img/ico_air_green.3716446e.png";